import { createAsyncThunk } from "@reduxjs/toolkit";

import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { doCreateProject, doDeleteProject, doListProject, doUpdateProject } from "../../services/project.service";

export const onGetProjectList = createAsyncThunk("project/getProjectList", async () => {
  try {
    const response: any = await doListProject(0);
    return response;
  } catch (error) {
    return error;
  }
});

export const onAddProject = createAsyncThunk("project/addProjectList", async (params: any) => {
  try {
    const data = await doCreateProject(params);
    toast.success("Project Added Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Project Added Failed", { autoClose: 2000 });
    return error;
  }
});

export const onUpdateProject = createAsyncThunk("project/updateProjectList", async (params: any) => {
  try {
    const data = await doUpdateProject(params);
    toast.success("Project updated Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Project updated Failed", { autoClose: 2000 });
    return error;
  }
});

export const onDeleteProject = createAsyncThunk("project/deleteProjectList", async (projectId: string) => {
  try {
    const data = await doDeleteProject(projectId);
    toast.success("Project deleted Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Project deleted Failed", { autoClose: 2000 });
    return error;
  }
});
